import request from "./base";
const path = "/api/admin/devtools";

export default {
  decryptBda: function (params) {
    return request().post(path + "/decrypt-bda", params);
  },
};
